module.exports = __webpack_public_path__ + "img/CM-AE-25-Honda-Modern.72e997ea.jpg";